enum APIResponseCode {
    WorkflowUserTaskStoredProcedureTimedOut = 26,
}

export default APIResponseCode;
